import Actions from '../actions/actions';
import { FacebookErrorModel } from '../model/FacebookErrorModel';

export type ErrorsState = {
  fbPageErrors: Record<number, FacebookErrorModel[]>;
};

const initialState: ErrorsState = {
  fbPageErrors: {},
};

export default function errors(state = initialState, action) {
  switch (action.type) {
    case Actions.SET_FACEBOOK_PAGE_ERRORS: {
      return {
        ...state,
        fbPageErrors: {
          ...state.fbPageErrors,
          [action.payload.id]: action.payload.facebookErrors,
        },
      };
    }
    case Actions.REMOVE_FACEBOOK_PAGE_ERROR: {
      const { facebookPageId, facebookErrorId } = action.payload;
      const { fbPageErrors } = state;

      if (!fbPageErrors || !facebookPageId || !facebookErrorId) {
        return state;
      }

      const errors = fbPageErrors[facebookPageId];

      if (!Array.isArray(errors) || !errors.length) {
        return state;
      }

      const updated = errors?.filter?.(err => err.id !== facebookErrorId);

      const update = {
        ...fbPageErrors,
        [facebookPageId]: updated,
      };

      return {
        ...state,
        fbPageErrors: update,
      };
    }
    default:
      return state;
  }
}
